var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-content"},[_c('iframe',{staticStyle:{"width":"100%","overflow":"hidden","height":"170px"},attrs:{"id":"iframe","src":"https://bulletin.cebpubservice.com/footer.html","frameborder":"no","scrolling":"no"}})])
}]

export { render, staticRenderFns }